export const COLLECTIONS = {
  userData: 'userData',
  companies: 'companies',
  companyProjects: 'companyProjects',
  auditLogs: 'auditLogs',
  exchangeRates: 'exchangeRates',
  experimentalFeatures: 'experimentalFeatures',
  experiments: 'experiments',
  forensicIntakes: 'forensicIntakes',
  premiumConfig: 'premium_config',
  fxInstitutions: 'fxInstitutions',
  fxMetadata: 'fxMetadata',
  reReturnRanges: 'reReturnRanges',
  reTierAdjustments: 'reTierAdjustments',
  reCountryTaxInfo: 'reCountryTaxInfo',
  gathererCommands: 'gathererCommands',
  gathererRuns: 'gathererRuns',
  gathererSources: 'gathererSources',
  systemMessages: 'systemMessages',
  feedback: 'feedback',
  translations: 'translations',
  appVersionControl: 'app_version_control',
  projectUpdateSuggestions: 'projectUpdateSuggestions',
  migrations: 'migrations',
  shieldScreenings: 'shieldScreenings',
  shieldWarningEntries: 'shieldWarningEntries',
  shieldRegistrySnapshots: 'shieldRegistrySnapshots',
  shieldMediaSnapshots: 'shieldMediaSnapshots',
  shieldMonitoringLog: 'shieldMonitoringLog',
  reDealsScraped: 'reDealsScraped',
  reDealScrapeRuns: 'reDealScrapeRuns',
  reDealAggregateCache: 'reDealAggregateCache',
  projectEditRequests: 'projectEditRequests',
  shieldScans: 'shield_scans',
  shieldReports: 'shield_reports',
  shieldSourceCache: 'shield_source_cache',
  // Data reliability
  dataProvenance: 'dataProvenance',
  scraperSources: 'scraperSources',
  reliabilityPoints: 'reliabilityPoints',
  reviewQueue: 'reviewQueue',
  companyScores: 'companyScores',
  gdprErasureLog: 'gdprErasureLog',
} as const;

/** Shield result freshness window for the approval review dialog. */
export const SHIELD_CACHE_TTL_MS = 15 * 60 * 1000;

export const SESSION = {
  maxDurationMs: 60 * 60 * 1000,
  inactivityMs: 5 * 60 * 1000,
  activityCheckIntervalMs: 30_000,
} as const;

export const AUDIT = {
  flushIntervalMs: 30_000,
  batchSize: 50,
} as const;

/** Flip each to true once the corresponding cloud function is deployed and working. */
export const CLOUD_FUNCTIONS = {
  scrapeFx: true, // stub deployed to dev + prod
  scrapeReDeals: true, // deployed from assetflow3/functions (estateguru, reinvest24)
  fetchFxRates: true, // deployed from assetflow3/functions (ECB rates)
  // Data reliability (not yet deployed)
  reconcilePayments: false,
  detectCollusion: false,
  computeCompanyScore: false,
  captureEventFxRate: false,
  gdprErasure: false,
} as const;
